const PERMISSION_KEY= "core:permission_group";
const PAGE_URL = {
    PERMISSION_GROUP_PAGE: "/admin/core/permission-group"
}

export {PERMISSION_KEY, PAGE_URL}

